import { DataBean } from "../DataBean";

export class SocialResponsibility extends DataBean {


    public async getSocialResponsibilityCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getSocialResponsibilityCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
    public async getSocialResponsibilityCatalogByPropertiesRender(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getSocialResponsibilityCatalogByPropertiesRender_java.util.Map_Number", [properties,maxRows]);
    }

    

 
}